module.exports = __webpack_public_path__ + "static/media/pannertikka.05b16c0f.jpg";